








import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import RuntimeComponent from "./RuntimeComponent";
import MagicBlockExt from "./MagicBlockExt.vue";

@Component({
  name: "GtMagic",
  components: { RuntimeComponent, MagicBlockExt }
})
export default class GtMagic extends Vue {
  @Prop({ required: true })
  public options!: App.WebForm.MagicFormConfig;

  get ext_form(): {
    enable: boolean;
    list: any[];
  } {
    if (this.options.ext_form) {
      return this.options.ext_form;
    } else {
      return {
        enable: false,
        list: []
      };
    }
  }

  checkParentContainTable(dom: HTMLElement): boolean {
    const p = dom.parentNode as HTMLElement;
    if (!p) {
      return false;
    }
    const tagName = p.tagName.toUpperCase();
    if (tagName === "BODY") {
      return false;
    } else if (tagName === "TABLE") {
      return true;
    } else {
      return this.checkParentContainTable(p);
    }
  }

  resetRootTableWidth() {
    const tables = this.$el.querySelectorAll("table");
    tables.forEach((d) => {
      const isContainTable = this.checkParentContainTable(d);
      if (!isContainTable) {
        d.style.width = this.options.width + "px";
      }
    });
  }

  @Watch("options.template", { immediate: true })
  onTemplateChange(newVal: string) {
    if (newVal === "" || !newVal) return;
    if (!this.options.width || this.options.width === 0 || this.options.width === "") return;
    this.$nextTick(() => {
      this.resetRootTableWidth();
    });
  }
}
